import { Fragment } from "react";

import useNTGroupAthletesBulkAdd from "./UseNTGroupAthletesBulkAdd";

import NTGroupsLoadingModal from "../components/dialogs/loading/NTGroupsLoadingModal";
import NTGroupAddAthletesFormGrid from "../components/grids/addAthletesForm/NTGroupAddAthletesFormGrid";

import Headings from "@usas/ui-web/components/headings/Headings";

const NTGroupAthletesBulkAdd = ({ updateAthletePillStep }) => {
  const {
    isSaving,
    gridData,
    onSubmitAthletesFormGrid,
    onEditGroupAthleteClicked
  } = useNTGroupAthletesBulkAdd(updateAthletePillStep);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Athletes</Headings.H3>
        </div>
      </div>
      <NTGroupAddAthletesFormGrid
        gridData={gridData}
        isLoading={gridData.length === 0}
        onEditClicked={onEditGroupAthleteClicked}
        onSubmitFormCallback={onSubmitAthletesFormGrid} />
      <NTGroupsLoadingModal isLoading={isSaving} />
    </Fragment>
  );
};

export default NTGroupAthletesBulkAdd;